// extracted by mini-css-extract-plugin
module.exports = {"iconContainer":"Home_iconContainer__2jbqc","iconText":"Home_iconText__3iwJ-"};